import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrending2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"trending-2, trends"} maskId="square-filled-radius-0-stroke-1-IconTrending2"><path fillRule="evenodd" clipRule="evenodd" d="M13.1438 21.907L18.4423 4.84025L21.2762 10.5452L22.1718 10.1004L18.2274 2.15977L12.9704 19.093L7.84057 7.73324L4.59037 13.1859L2.64232 10.2446L1.80859 10.7967L4.63494 15.0642L7.71808 9.89178L13.1438 21.907Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTrending2;
